import LandingSocialMediaLinks from './LandingSocialMediaLinks';

export default LandingSocialMediaLinks;
